module.exports = __webpack_public_path__ + "img/body-3.7486a97b.png";